import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouteGuardService } from './config/route-guard.service';

import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { GoogleLoginComponent } from './admin/google-login/google-login.component';
import { ContentComponent } from './admin/layouts/content/content.component';
import { NotFoundComponent } from './admin/not-found/not-found.component';
import { ForgotPasswordComponent } from './admin/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './admin/auth/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'career-portal',
    loadChildren: () => import('./career-portal/career-portal.module').then(m => m.CareerPortalModule)
  },
  {
    path: 'login',
    component: GoogleLoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: '',
    component: ContentComponent,
    children: [
      {
        path: 'dashboard',
        canActivate: [RouteGuardService],
        component: DashboardComponent,
        data: {
          title: 'Dashboard',
          breadcrumb: [
            {
              label: 'Home',
              url: '/dashboard'
            },
            {
              label: 'Dashboard',
              url: ''
            }
          ]
        },
      },
      {
        path: '',
        component: DashboardComponent
      },
      {
        path: 'management',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/management/management.module').then(m => m.ManagementModule)
      },
      {
        path: 'project-management',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/project-management/project-management.module').then(m => m.ProjectManagementModule)
      },
      {
        path: 'client-management',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/client-management/client-management.module').then(m => m.ClientManagementModule)
      },
      {
        path: 'billability',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/billability/billability.module').then(m => m.BillabilityModule)
      },
      {
        path: 'profile',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'career',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/career/career.module').then(m => m.CareerModule)
      },
      {
        path: 'purchase-management',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/purchase-management/purchase-management.module').then(m => m.PurchaseManagementModule)
      },
      {
        path: 'pr-request-approve',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/pr-request-approve/pr-request-approve.module').then(m => m.PrRequestApproveModule)
      },
      {
        path: 'resource-management',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/resource-management/resource-management.module').then(m => m.ResourceManagementModule)
      },
      {
        path: 'sops',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/sops/sops.module').then(m => m.SopsModule)
      },
      {
        path: 'resume',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/resume/resume.module').then(m => m.ResumeModule)
      },
      {
        path: 'pms-logs',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/pms-logs/pms-logs.module').then(m => m.PmsLogsModule)
      },
      {
        path: 'resource-request-approve',
        canActivate: [RouteGuardService],
        loadChildren: () => import('./admin/resource-request-approve/resource-request-approve.module').then(m => m.ResourceRequestApproveModule)
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
